import { render } from "./naverAds.vue?vue&type=template&id=58bfbedf&scoped=true"
import script from "./naverAds.vue?vue&type=script&lang=js"
export * from "./naverAds.vue?vue&type=script&lang=js"

import "./naverAds.vue?vue&type=style&index=0&id=58bfbedf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bfbedf"]])

export default __exports__